import { SectionTypes } from '@fiverr-private/ai_brief';
import { screeningQuestionsSectionID } from '../../../components/Sections/ScreeningQuestions';
import { appTranslate } from '../../../i18n';
import type { BuyerBriefOverviewResponse } from '../types';

export const getScreeningQuestionsSeed = (
    brief: BuyerBriefOverviewResponse,
    suggestedTextToKeyMap: Map<string, string>
) => {
    if (!brief.screeningQuestions?.length) {
        return [];
    }

    return [
        {
            id: screeningQuestionsSectionID,
            title: appTranslate('sections.screening_questions.title'),
            included: true,
            type: SectionTypes.dynamic,
            content: {
                questions: brief.screeningQuestions.map((sq) => {
                    const matchedKey = sq.kind === 'SUGGESTED' ? suggestedTextToKeyMap.get(sq.question) : null;

                    return {
                        id: sq.id,
                        text: sq.question,
                        ...(matchedKey ? { suggestedQuestionId: matchedKey } : {}),
                    };
                }),
            },
        },
    ];
};
